import api from "./client";

export async function listTasks(params = {}) {
  const res = await api.get("/tasks", { params });
  return res.data.data.items;
}

export async function getTaskActivities(id) {
  const res = await api.get(`/tasks/${id}/activities`);
  return res.data.data.items;
}

export async function createTask(payload) {
  const res = await api.post("/tasks", payload);
  return res.data.data;
}

export async function updateTask(id, payload) {
  const res = await api.put(`/tasks/${id}`, payload);
  return res.data.data;
}

export async function completeTask(id) {
  const res = await api.post(`/tasks/${id}/complete`);
  return res.data.data;
}

export async function reopenTask(id) {
  const res = await api.post(`/tasks/${id}/reopen`);
  return res.data.data;
}

export async function cancelTask(id, reason = null) {
  const res = await api.post(`/tasks/${id}/cancel`, { reason });
  return res.data.data;
}

export async function addTaskNote(id, note) {
  const res = await api.post(`/tasks/${id}/notes`, { note });
  return res.data.data;
}

export async function getTaskSummary() {
  const res = await api.get("/tasks/summary");
  return res.data.data;
}

export async function listTaskNotifications(limit = 10) {
  const res = await api.get("/tasks/notifications", { params: { limit } });
  return res.data.data.items;
}

export async function markTaskNotificationsRead(ids = null) {
  const res = await api.post("/tasks/notifications/read", ids ? { ids } : {});
  return res.data.data;
}
